import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
import { getPortalId } from '../../common/utils';
import { defineComponent } from '../../platform/models';
import { ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT } from '../constants';
import { Z_INDEX_NAV_COMPONENT_ACADEMY } from '../../constants/z_index';
export const ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT_ID = 'academy-exercise-instructions';
export const academyExerciseInstructionsNavComponentDef = defineComponent(ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT, {
  name: ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT,
  path: `/academy-navigation-components/${getPortalId()}/exercise-instructions`,
  capabilities: [capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.NAVIGATE_TO_CAP.getName()],
  iframeProps: {
    id: ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT_ID,
    ['data-test-id']: ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT_ID,
    style: {
      maxWidth: '440px',
      width: '100%',
      height: 'calc(100% - 56px)',
      top: '56px',
      right: '20px',
      position: 'fixed',
      borderRadius: 3,
      zIndex: Z_INDEX_NAV_COMPONENT_ACADEMY
    }
  },
  propsSchema: {
    description: args.string(),
    exerciseLocation: args.string(),
    isGraded: args.bool(),
    isSimulation: args.bool(),
    isManuallyGraded: args.bool()
  },
  initialProps: {
    description: '',
    exerciseLocation: '',
    isGraded: false,
    isSimulation: false,
    isManuallyGraded: false
  },
  initiallyOpen: false,
  deferLoading: true
});